<template>
<NavigationMenu />
  <div class="container mx-auto px-4 py-12 sm:py-16">
    <!-- Header da Home -->
    <div class="text-center mb-12">
      <h1 class="text-4xl sm:text-5xl font-bold text-white mb-4 drop-shadow-lg">
        Bem-vindo ao Papo de Boleiro
      </h1>
      <p class="text-xl text-green-100 drop-shadow">
        Escolha sua experiência de futebol
      </p>
    </div>

    <!-- Grid de Cards -->
    <div class="grid grid-cols-1 lg:grid-cols-2 gap-8 max-w-5xl mx-auto">
      
      <!-- Card Bolão -->
      <div class="group relative bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-3xl">
        <div class="absolute inset-0 bg-gradient-to-br from-green-600 to-green-700 opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
        
        <div class="relative p-8 sm:p-10">
          <!-- Ícone -->
          <div class="mb-6">
            <div class="w-20 h-20 bg-gradient-to-br from-green-600 to-green-700 rounded-2xl flex items-center justify-center shadow-lg transform group-hover:rotate-6 transition-transform duration-300">
              <i class="fas fa-trophy text-white text-4xl"></i>
            </div>
          </div>

          <!-- Conteúdo -->
          <h2 class="text-3xl font-bold text-gray-900 mb-3">
            Bolão do Brasileirão
          </h2>
          <p class="text-gray-600 mb-8 leading-relaxed">
            Faça seus palpites, acompanhe os placares e dispute com os amigos. Veja o ranking e prove quem entende mais de futebol!
          </p>

          <!-- Features -->
          <div class="space-y-3 mb-8">
            <div class="flex items-center gap-3 text-gray-700">
              <i class="fas fa-check-circle text-green-600"></i>
              <span class="text-sm">Palpites de todos os jogos</span>
            </div>
            <div class="flex items-center gap-3 text-gray-700">
              <i class="fas fa-check-circle text-green-600"></i>
              <span class="text-sm">Ranking atualizado</span>
            </div>
            <div class="flex items-center gap-3 text-gray-700">
              <i class="fas fa-check-circle text-green-600"></i>
              <span class="text-sm">Relatórios detalhados</span>
            </div>
          </div>

          <!-- Botão -->
          <router-link 
            to="/ranking" 
            class="inline-flex items-center justify-center w-full gap-2 px-6 py-4 bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform group-hover:translate-y-0">
            <span>Acessar Bolão</span>
            <i class="fas fa-arrow-right group-hover:translate-x-1 transition-transform duration-300"></i>
          </router-link>
        </div>

        <!-- Imagem decorativa -->
        <div class="hidden sm:block absolute bottom-0 right-0 w-48 h-48 opacity-10 group-hover:opacity-20 transition-opacity duration-300">
          <img src="@/assets/images/bolao.svg" class="w-full h-full object-contain" />
        </div>
      </div>

      <!-- Card Futebol -->
      <div class="group relative bg-white rounded-2xl shadow-2xl overflow-hidden transform transition-all duration-300 hover:scale-105 hover:shadow-3xl">
        <div class="absolute inset-0 bg-gradient-to-br from-blue-600 to-blue-700 opacity-0 group-hover:opacity-10 transition-opacity duration-300"></div>
        
        <div class="relative p-8 sm:p-10">
          <!-- Ícone -->
          <div class="mb-6">
            <div class="w-20 h-20 bg-gradient-to-br from-blue-600 to-blue-700 rounded-2xl flex items-center justify-center shadow-lg transform group-hover:rotate-6 transition-transform duration-300">
              <i class="fas fa-futbol text-white text-4xl"></i>
            </div>
          </div>

          <!-- Conteúdo -->
          <h2 class="text-3xl font-bold text-gray-900 mb-3">
            Futebol
          </h2>
          <p class="text-gray-600 mb-8 leading-relaxed">
            Explore o histórico completo dos jogadores do melhor grupo de futebol. Veja artilheiros, melhores jogadores do ano, estatísticas individuais e muito mais.
          </p>

          <!-- Features -->
          <div class="space-y-3 mb-8">
            <div class="flex items-center gap-3 text-gray-700">
              <i class="fas fa-check-circle text-blue-600"></i>
              <span class="text-sm">Histórico de cada jogador</span>
            </div>
            <div class="flex items-center gap-3 text-gray-700">
              <i class="fas fa-check-circle text-blue-600"></i>
              <span class="text-sm">Artilheiros e melhores do ano</span>
            </div>
            <div class="flex items-center gap-3 text-gray-700">
              <i class="fas fa-check-circle text-blue-600"></i>
              <span class="text-sm">Estatísticas individuais</span>
            </div>
          </div>

          <!-- Botão -->
          <router-link 
            to="/standings" 
            class="inline-flex items-center justify-center w-full gap-2 px-6 py-4 bg-gradient-to-r from-blue-600 to-blue-700 hover:from-blue-700 hover:to-blue-800 text-white font-semibold rounded-xl shadow-lg hover:shadow-xl transition-all duration-300 transform group-hover:translate-y-0">
            <span>Ver Estatísticas</span>
            <i class="fas fa-arrow-right group-hover:translate-x-1 transition-transform duration-300"></i>
          </router-link>
        </div>

        <!-- Imagem decorativa -->
        <div class="hidden sm:block absolute bottom-0 right-0 w-48 h-48 opacity-10 group-hover:opacity-20 transition-opacity duration-300">
          <img src="@/assets/images/racha.svg" class="w-full h-full object-contain" />
        </div>
      </div>

    </div>

    <!-- Informação adicional -->
    <div class="mt-16 text-center">
      <div class="inline-flex items-center gap-2 px-6 py-3 bg-white bg-opacity-20 backdrop-blur-sm rounded-full text-white shadow-lg">
        <i class="fas fa-users"></i>
        <span class="text-sm font-medium">Participe da comunidade de amantes do futebol</span>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import NavigationMenu from '@/components/NavigationMenu.vue'

export default {
  name: 'HomeView',
  components: {
    NavigationMenu
  }
}
</script>
